import baseapi from "../baseAPI";
import {successMesg, errorMesg, infoMessage, warningMesg} from "./../../Pages/Toaster";

export const DashboardAPI = async (setFreshLeadCount, setPendingFollowupCount, setTodayFollowupCount, setIsStatReload, setWarmCount) =>
{
      

    try
    {
        const response = await baseapi.get('api/sales/dashboard');

        console.log("Data got successfully", response.data.warmleads);
        
        //setUsersList(response.data.data.data);
        setFreshLeadCount(response.data.freshleads);
        setPendingFollowupCount(response.data.pendingfollowups);
        setTodayFollowupCount(response.data.todayfollowups);
        setWarmCount(response.data.warmleads);
        setIsStatReload(false);
        //setNotifications();
        //return response;

        

    }
    catch(error)
    {
        console.error("Error in user list:", error);

        
    }
}

export const getTeamsAPI = async (setTeams) =>
{
      

    try
    {
        const response = await baseapi.get('api/sales/teamlist');

        //console.log("Data got successfully", response.data.usercount);
        
        //setUsersList(response.data.data.data);
        setTeams(response.data.teamlist);
        //return response;

        

    }
    catch(error)
    {
        console.error("Error in user list:", error);

        
    }
}

export const DashboardTeamFilterAPI = async (setNewLeadCount, setPendingFollowupCount, setTodayFollowupCount, params) =>
{
    //setLoading(true);

    try 
    {
        const response = await baseapi.post('api/sales/dashboard-team-filter', params);

        //console.log("Data got successfully", response);

        setNewLeadCount(response.data.freshleads);
        setPendingFollowupCount(response.data.totalfollowup);
        setTodayFollowupCount(response.data.dashboard.todayfollowup);

    } 
    catch (error) 
    {
        console.error("Error in user list:", error);
        
        errorMesg("Lead has not been added. Please try again!!!");
    }
}

export const getTeamCampaignListAPI = async (teamid, setCampaigns) =>
{
    try
    {
        const response = await baseapi.get('api/sales/filter/campaigns/' + teamid);

        //console.log("Data got successfully", response.data.usercount);
        
        //setUsersList(response.data.data.data);
        setCampaigns(response.data.datalist);
        //return response;

        

    }
    catch(error)
    {
        console.error("Error in user list:", error);

        
    }
}

export const getFilterCallerListAPI = async (campaignid, setCallers) =>
{
    try
    {
        const response = await baseapi.get('api/sales/filter/callers/' + campaignid);

        //console.log("Data got successfully", response.data.usercount);
        
        //setUsersList(response.data.data.data);
        setCallers(response.data.datalist);
        //return response;

        

    }
    catch(error)
    {
        console.error("Error in user list:", error);

        
    }
}

export const DashboardFilterAPI = async (filterparams, setFreshLeadCount, setPendingFollowupCount, setTodayFollowupCount, setWarmCount, setFilterParam) =>
{
      
    let searchparam = "";

    if(filterparams !== "" && filterparams !== null && filterparams !== undefined)
    {
        searchparam = `?${filterparams.toString()}`;
    }
    else
    {
        searchparam = "";
    }

    try
    {
        const response = await baseapi.get('api/sales/dashboard' + searchparam);

        console.log("Data got successfully", response.data.warmleads);
        
        //setUsersList(response.data.data.data);
        setFreshLeadCount(response.data.freshleads);
        setPendingFollowupCount(response.data.pendingfollowups);
        setTodayFollowupCount(response.data.todayfollowups);
        setWarmCount(response.data.warmleads);
        //setNotifications();
        //return response;
        setFilterParam('?' + filterparams);
        

    }
    catch(error)
    {
        console.error("Error in user list:", error);

        
    }
}

/*export const DashboardAPI = async (setCampaignsList, setTeamCount, setCampaignCount, setLeadCount, setConvertedLeadCount, setLoading) =>
{
    setLoading(true);    

    try
    {
        const response = await baseapi.get('api/sales/dashboard');

        //console.log("Data got successfully", response.data.usercount);
        
        //setUsersList(response.data.data.data);
        setTeamCount(response.data.teamcount);
        setCampaignCount(response.data.campaigncount);
        setLeadCount(response.data.dashboard.totalcount);
        setConvertedLeadCount(response.data.dashboard.converted);
        setCampaignsList(response.data.campaigns);
        //return response;

        setLoading(false);

    }
    catch(error)
    {
        console.error("Error in user list:", error);

        setLoading(false);
    }
}*/

/*export const LeadPerformanceReportAPI = async (setLeadPerformSeries, setLeadPerformOptions, setShowLeadPerformChart, filterparams) =>
{

    setShowLeadPerformChart(true);

    try
    {
        const response = await baseapi.get("/api/sales/lead-performance-report" + `?${filterparams.toString()}`);

        //console.log("Data got successfully", response.data);
        
        //setUsersList(response.data.data.data);
        setLeadPerformSeries(response.data.series);
        setLeadPerformOptions(response.data.options);
        
        setShowLeadPerformChart(false);
    }
    catch(error)
    {
        console.error("Error in user list:", error);
        setShowLeadPerformChart(false);
    }
}*/

